module.exports = __webpack_public_path__ + "img/spfl.821e38ac.png";